import {getENV} from "../utils";
import {BASE_PARAMS, PASSWORD} from "../config";
import {handlerResponseText} from "../cryptojs";

export const UploadMixin = {
    data() {
        return {
            UPLOAD_URL: getENV().api,
            UPLOAD_PARAMS: {...BASE_PARAMS, service: "nethos.system.atta.upload"},
            UPLOAD_HEADERS: {
                sign: hex_md5(hex_md5(PASSWORD) + BASE_PARAMS.spid + BASE_PARAMS.random)
            },
            picList: [],
            fileList: []
        };
    },
    created() {
    },
    methods: {
        beforeUpload(file) {
            if (file.type.indexOf("image") < 0) {
                this.$message.error("格式错误");
                return false;
            }
        },
        uploadOnError(error, file, fileList) {
            Log("error", error, file, fileList);
            this.$message.error("上传失败");
        },
        onSuccessPic(response, file, fileList) {
            if (typeof response === 'string') response = handlerResponseText(response);
            if (response && response.code !== "0") {
                this.$message.error(response.msg);
                this.picList = fileList.map(f => {
                    if (f.response && f.uid === file.uid) f.status = "error";
                    return f;
                });
            } else {
                this.picList = fileList;
            }
        },

        onSuccessFile(response, file, fileList) {
            if (typeof response === 'string') response = handlerResponseText(response);
            if (response && response.code !== "0") {
                this.$message.error(response.msg);
                this.fileList = fileList.map(f => {
                    if (f.response && f.uid === file.uid) f.status = "error";
                    return f;
                });
            } else {
                this.fileList = fileList;
            }
        },
        onExceed() {
            this.$message.error(
                "最多可上传9张图片，支持jpg、png、gif、bmp、PDF格式。"
            );
        },
        handlerAttaIdList(list) {
            return list
                .filter(r => {
                    let {response} = r;
                    if (response && typeof response === 'string') r.response = handlerResponseText(response);
                    return r.response && r.response.code === "0";
                })
                .map(r => {
                    return (r.response && r.response.obj && r.response.obj.attaId) || r.attaId;
                });
        },
        beforeUploadFile(file) {
            let fileName = file.name;
            let pos = fileName.lastIndexOf(".");
            let lastName = fileName.substring(pos + 1, fileName.length);
            let type = file.type || lastName;
            Log('type', type);
            let has = ['text/plain', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/zip', 'rar', 'application/x-zip-compressed', 'application/octet-stream'].includes(type);
            let size = file.size / 1024 / 1024;
            // if(type == 'text/plain'){
            //     this.upload_file.fileType = 'TEXT';
            // }else{
            //     this.upload_file.fileType = 'OTHER';
            // }
            if (!has) {
                this.$message.error('不支持该类型的文件。');
                return false;
            }
            if (size > 30) {
                this.$message.error('文件过大');
                return false;
            }
        }
    }
};
